'use es6';

export const DISPLAY_ON_SCROLL_PERCENTAGE = ['displayOnScrollPercentage'];
export const DISPLAY_ON_TIME_DELAY = ['displayOnTimeDelay'];
export const DISPLAY_ON_EXIT_INTENT = ['displayOnExitIntent'];